export * from './BuildingHomeIcon';
export * from './BuildingHomeIcon16Light';
export * from './BuildingHomeIcon16Regular';
export * from './BuildingHomeIcon16Solid';
export * from './BuildingHomeIcon20Light';
export * from './BuildingHomeIcon20Regular';
export * from './BuildingHomeIcon20Solid';
export * from './BuildingHomeIcon24Regular';
export * from './BuildingHomeIcon24Solid';
export * from './BuildingHomeIcon32Regular';
export * from './BuildingHomeIcon64Regular';
